module.exports = __webpack_public_path__ + "media/images/registration/dod_employee_user-4a3321e804ab8fd7503f3dd3819a6f1d.png";